import React from 'react';

interface FeaturesIconProps {
  className?: string;
}

const FeaturesIcon: React.FC<FeaturesIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="m5,6c0-.553.448-1,1-1h3c.552,0,1,.447,1,1s-.448,1-1,1h-3c-.552,0-1-.447-1-1Zm6,3h-5c-.552,0-1,.447-1,1s.448,1,1,1h5c.552,0,1-.447,1-1s-.448-1-1-1Zm0,4h-5c-.552,0-1,.447-1,1s.448,1,1,1h5c.552,0,1-.447,1-1s-.448-1-1-1Zm12.939-8.343c-.144-.395-.52-.657-.939-.657h-3.001l-1.062-2.98c-.146-.391-.52-.651-.937-.651s-.792.26-.937.651l-1.062,2.98h-3.001c-.419,0-.794.262-.938.655-.145.394-.028.835.292,1.107l2.377,1.935-.941,3.016c-.127.405.015.846.354,1.101.177.133.388.2.6.2.194,0,.388-.056.556-.169l2.708-1.812,2.754,1.793c.355.231.819.213,1.156-.046.337-.259.473-.703.339-1.106l-.979-2.98,2.366-1.927c.321-.271.439-.713.295-1.108Zm-1.939,15.343v.5c0,1.93-1.57,3.5-3.5,3.5H3.499c-1.929,0-3.499-1.57-3.499-3.5V5C0,2.243,2.243,0,5,0h8c.552,0,1,.447,1,1s-.448,1-1,1H5c-1.654,0-3,1.346-3,3v15.5c0,.827.673,1.5,1.5,1.5s1.5-.673,1.5-1.5v-.5c0-1.654,1.346-3,3-3h9v-3c0-.553.448-1,1-1s1,.447,1,1v3c1.654,0,3,1.346,3,3Zm-2,0c0-.552-.449-1-1-1h-11c-.551,0-1,.448-1,1v.5c0,.536-.122,1.045-.338,1.5h11.838c.827,0,1.5-.673,1.5-1.5v-.5Z"/>
    </svg>
  );
};

export default FeaturesIcon;
